import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content"]

  toggle(event) {
    event.preventDefault()

    this.contentTarget.classList.remove("hidden")
    this.buttonTarget.remove()
  }
}
